import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  Icon,
} from "../../../../../components";
import { history } from "../../../../../services";

const ErrosDfeDialog = ({
  open,
  setOpen,
  errosDfe,
  onClickCriarContingenciaNfSaidaPendente,
  nfSaida,
}) => {
  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form>
        <DialogContent>
          <CardHeader
            title="Erros Dfe"
            action={
              <>
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{
                      color: errosDfe?.status === 400 ? "#EA9D2B" : "#DC3545",
                    }}
                  ></i>
                </Icon>
              </>
            }
          />
          <CardContent>
            <Grid container className="mt-3">
              <Typography>{errosDfe?.mensagem}</Typography>
            </Grid>
          </CardContent>
          <CardActions className="d-flex justify-content-end">
            {nfSaida?.modeloDocumento === "65" && (
              <Button
                variant="contained"
                color="padrao"
                onClick={() => {
                  setOpen(false);
                  onClickCriarContingenciaNfSaidaPendente();
                }}
              >
                Emitir em Contingência
              </Button>
            )}
            <Button
              variant="contained"
              color="padrao"
              onClick={() => {
                if (nfSaida.id) {
                  history.push(`/faturamento/nf-saida/${nfSaida.id}`);
                }
                setOpen(false);
              }}
            >
              Fechar
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginLeft: 10 }}
              ></i>
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default ErrosDfeDialog;
